export const SEARCH_FIELD_MAX_LENGTH = 255
